import PropTypes from 'prop-types';
import React from 'react';
import en from '../../intl/translations/en';

const SpotReportCamHeaderCTA = ({ href, onClickPaywall }) => (
  <div className="sl-spot-report-cam-header-cta">
    <span className="sl-spot-report-cam-header-cta__text">
      {en.premiumCTA.SpotReportCamHeaderCTA.text}
    </span>
    <a href={href} className="sl-spot-report-cam-header-cta__link" onClick={onClickPaywall}>
      {en.premiumCTA.SpotReportCamHeaderCTA.linkText}
    </a>
  </div>
);

SpotReportCamHeaderCTA.defaultProps = {
  href: null,
  onClickPaywall: null,
};

SpotReportCamHeaderCTA.propTypes = {
  href: PropTypes.string,
  onClickPaywall: PropTypes.func,
};

export default SpotReportCamHeaderCTA;
